import _ from 'lodash'
import * as NavActions from 'x/utils/navigation'
import p from 'x/config/platform-specific'
import * as util from 'x/utils/util'
import CONS from 'x/config/constants'
import { SubscriptionPackageListItems } from '..'

export function navToSubscriptionChoiceView(navigation: any, navKey: string): void {
  const subscription = util.getSubscriptionFromRedux()
  // console.log('subscription => ', subscription.toJS())
  const type = subscription.get('type')
  // console.log('type => ', type)
  if (_.isNil(type)) {
    return
  }

  const unit = util.getUnitNameByDataJsonKey(navKey)
  const is_package_main_upgradable = subscription.has('is_package_main_upgradable') ? subscription.get('is_package_main_upgradable') : false
  if (type === 1) {
    p.op.showConfirmation(
      `แพ็กเกจของคุณไม่เพียงพอสำหรับการเพิ่ม${unit}`,
      `กดปุ่ม "ซื้อแพ็กเกจ" เพื่อเพิ่ม${unit}`,
      () => navigation.dispatch(NavActions.navToSubscriptionView({ isHideSubscriptionWarning: true, addOnDubledNavKey: 'buy_package' })),
      () => null,
      'ซื้อแพ็กเกจ',
      'ปิด'
    )
  }

  if (type >= 2 && type <= 4) {
    p.op.showConfirmationThreeButtons(
      `แพ็กเกจของคุณไม่เพียงพอสำหรับการเพิ่ม${unit}`,
      `กดปุ่ม "อัพเกรดแพ็กเกจ"  หรือ "ซื้อแพ็กเสริม" เพื่อเพิ่ม${unit}`,
      'อัพเกรดแพ็กเกจ',
      () => {
        if (is_package_main_upgradable) {
          navigation.dispatch(NavActions.navToSubscriptionView({ isHideSubscriptionWarning: true, addOnDubledNavKey: 'upgrade' }))
        } else {
          p.op.showToast('เกิดข้อผิดพลาด กรุณาติดต่อทีมงาน', 'warning')
        }
      },
      'ซื้อแพ็กเสริม',
      () => navigation.dispatch(NavActions.navToSubscriptionView({ isHideSubscriptionWarning: true, addOnDubledNavKey: navKey })),
      'ปิด',
      () => null
    )
  }

  if (type === 5) {
    p.op.showConfirmation(
      `แพ็กเกจของคุณไม่เพียงพอสำหรับการเพิ่ม${unit}`,
      `กดปุ่ม "ซื้อแพ็กเสริม" เพื่อเพิ่ม${unit}`,
      () => navigation.dispatch(NavActions.navToSubscriptionView({ isHideSubscriptionWarning: true, addOnDubledNavKey: navKey })),
      () => null,
      'ซื้อแพ็กเสริม',
      'ปิด'
    )
  }

  if (type === 999) {
    p.op.showConfirmation(
      `แพ็กเกจของคุณไม่เพียงพอสำหรับการเพิ่ม${unit}`,
      `กดปุ่ม "ซื้อแพ็กเกจ" เพื่อเพิ่ม${unit}`,
      () =>
        navigation.dispatch(NavActions.navToSubscriptionView({ isHideSubscriptionWarning: true, addOnDubledNavKey: 'continue_package' })),
      () => null,
      'ซื้อแพ็กเกจ',
      'ปิด'
    )
  }
}

export function pendingModeCheck(
  selectedMainPackage: SubscriptionPackageListItems,
  mode: 'upgrade' | 'buy_package' | 'add_on' | 'continue_package' | 'pending'
): 'upgrade' | 'buy_package' | 'add_on' | 'continue_package' | 'pending' {
  if (_.isNil(selectedMainPackage)) {
    return mode
  }
  const { sku } = selectedMainPackage
  if (CONS.SUBSCRIPTION_UPGRADE_PACKAGE_SKU.includes(sku)) {
    return 'upgrade'
  }
  return mode
}
